export default function TipBand() {
  return (
    <section id="tip" className="w-full py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-primary-500 px-6 py-10 md:px-10 md:py-14">
          <div className="absolute inset-0 opacity-[0.08]" aria-hidden="true">
            <div className="grid h-full w-full grid-cols-6 gap-4">
              {Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className="border-r border-background-50" />
              ))}
            </div>
          </div>
          <div className="relative flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
            <div className="max-w-xl">
              <p className="inline-flex items-center gap-2 font-label text-xs font-semibold uppercase tracking-[0.2em] text-background-50/80">
                <i className="ri-send-plane-line" />
                Tip &amp; 内幕线索
              </p>
              <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
                你手上那份未公开的细节，
                <br className="hidden sm:block" />
                也许正是别人缺的最后一块拼图。
              </h2>
              <p className="mt-3 font-body text-sm leading-relaxed text-background-50/90">
                收到线索后我们会先交叉核实来源，再决定是否进入深挖流程。自由匿名、可撤回，一切以可查证为前提。
              </p>
            </div>
            <div className="flex shrink-0 flex-col gap-3">
              <button
                type="button"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-background-50 px-6 py-3 font-label text-sm font-bold text-primary-600 transition-colors hover:bg-background-100"
              >
                <i className="ri-fire-line mr-2 text-lg leading-none" />
                匿名提交线索
              </button>
              <p className="font-label text-center text-xs text-background-50/70 lg:text-right">
                静默处理 · 不公开信息源
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}